import React from "react";

const NonceConcept = () => {
  return (
    <div>
      <p className="step-p"> The nonce is the number used to find a valid hash. </p>

      <p> To find a valid hash, we need to find a nonce value that will produce a valid hash when used with the rest of the information from that block. </p>
    </div>
  );
};

export default NonceConcept;





// WEBPACK FOOTER //
// ./src/steps/nonce/concept.js